import React, { MouseEventHandler, FC } from 'react'
import {
  IconSystemChevronLeft,
  IconSystemChevronRight,
} from '@moonpig/launchpad-assets'
import { TertiaryButton, Text } from '@moonpig/launchpad-components'
import { breakpoint, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { breakpointDown } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import { useGetBreakpoint } from '@moonpig/web-core-utils'

const BREAKPOINT = 'lg'

const StyledTertiaryButtonRight = styled(TertiaryButton)`
  text-align: left;
  ${s({ py: 4 })}
  ${breakpointDown(BREAKPOINT)} {
    display: none;
  }
`

const StyledTertiaryButtonLeft = styled(TertiaryButton)`
  text-align: left;
  ${s({ py: 4, ml: -4 })}
  ${breakpoint(BREAKPOINT)} {
    display: none;
  }

  span {
    ${({ theme }) =>
      s({
        gap: spacingPx(2)({ theme }),
      })}
  }
`

const StyledCurrentPage = styled(Text)`
  ${breakpointDown(BREAKPOINT)} {
    display: none;
  }
`

export type BreadcrumbProps = {
  url: string
  label: React.ReactNode
  parentPage: boolean
  currentPage: boolean
  showIntermediateLink: boolean
  onClickHandler: MouseEventHandler<HTMLElement>
}

export const Breadcrumb: FC<BreadcrumbProps> = ({
  url,
  label,
  parentPage,
  currentPage: displayCurrentPage,
  showIntermediateLink,
  onClickHandler,
}): React.ReactElement | null => {
  const getBreakpoint = useGetBreakpoint()
  const largeBreakpoint =
    getBreakpoint === 'lg' || getBreakpoint === 'xl' || getBreakpoint === 'xxl'
  const displayButtonRight =
    (parentPage && largeBreakpoint) || showIntermediateLink
  const displayButtonLeft = parentPage && !largeBreakpoint

  if (displayButtonLeft) {
    return (
      <StyledTertiaryButtonLeft
        href={url}
        leadingIcon={<IconSystemChevronLeft />}
        aria-hidden
        tabIndex={-1}
        onClick={onClickHandler}
      >
        {label}
      </StyledTertiaryButtonLeft>
    )
  }

  if (displayCurrentPage) {
    return <StyledCurrentPage aria-current="page">{label}</StyledCurrentPage>
  }

  if (displayButtonRight) {
    return (
      <StyledTertiaryButtonRight
        href={url}
        trailingIcon={<IconSystemChevronRight />}
        onClick={onClickHandler}
      >
        {label}
      </StyledTertiaryButtonRight>
    )
  }

  /* istanbul ignore next */
  return null
}
